import { render, staticRenderFns } from "./top-ads.vue?vue&type=template&id=57159c9d"
import script from "./top-ads.vue?vue&type=script&lang=js"
export * from "./top-ads.vue?vue&type=script&lang=js"
import style0 from "./top-ads.vue?vue&type=style&index=0&id=57159c9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports